import { Box, Divider, Tag, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { DepartmentDto } from "../../../../autogen/bff-api";

interface Props {
  department: DepartmentDto;
}

export const ContractDepartment = ({ department }: Props) => {
  const { t } = useTranslation();

  return (
    <Box padding="15px" paddingBottom={"20px"} w="100%">
      <Text as="h2" fontWeight={"bold"} fontSize="sm" color="smMuted">
        {t("Department")}
      </Text>
      <Divider marginTop={"5px"} marginBottom={"5px"} />
      <Tag mt="13px">{department.name}</Tag>
    </Box>
  );
};
